module.exports = __webpack_public_path__ + "static/HKGrotesk-Italic-6e0c778fb760affc0a3204968b622bdd.woff";